export const SET_PAID_AD_ID = 'SET_PAID_AD_ID'
export const setPaidAdId = (payload) => ({ type: SET_PAID_AD_ID, payload })
